export default {
  SET_ITEMS(state, items) {
    state.countries = items || [];
  },
  ADD_ITEM(state, item) {
    state.countries.unshift(item);
  },
  UPDATE_ITEM(state, item) {
    const index = state.countries.findIndex(x => x.ID === item.ID);
    if (index !== -1) state.countries.splice(index, 1, item);
  },
  REMOVE_ITEM(state, id) {
    state.countries = state.countries.filter(x => x.ID !== id);
  }
};
